import { Button as BaseButton, ButtonProps, ButtonGroup as BaseButtonGroup, ButtonGroupProps } from "@mui/material";
import _ from "lodash";
import { getDataProps, type WithDataProps } from "../../shared/utilities";
import { forwardRef, type ForwardedRef } from "react";

export const Button = forwardRef((props: WithDataProps<ButtonProps>, ref: ForwardedRef<HTMLButtonElement>) => <BaseButton ref={ref} {...props} {...getDataProps(props)} />);
export const PrimaryButton = forwardRef((props: WithDataProps<ButtonProps>, ref: ForwardedRef<HTMLButtonElement>) => <BaseButton ref={ref} variant="contained" color="primary" {...props} {...getDataProps(props)} />);
export const SecondaryButton = forwardRef((props: WithDataProps<ButtonProps>, ref: ForwardedRef<HTMLButtonElement>) => <BaseButton ref={ref} variant="contained" color="secondary" {...props} {...getDataProps(props)} />);
export const TertiaryButton = forwardRef((props: WithDataProps<ButtonProps>, ref: ForwardedRef<HTMLButtonElement>) => <BaseButton ref={ref} variant="outlined" color="primary" {...props} {...getDataProps(props)} />);
export const LinkButton = forwardRef((props: WithDataProps<ButtonProps>, ref: ForwardedRef<HTMLButtonElement>) => <BaseButton ref={ref} variant="text" color="primary" {...props} {...getDataProps(props)} />);
export const ButtonGroup = forwardRef((props: WithDataProps<ButtonGroupProps>, ref: ForwardedRef<HTMLDivElement>) => {
    const { children, ...rest } = props;

    // Workaround for the fact that JSX Parser wraps whitespace-enclosed elements in a fragment by default...
    const sanitizedChildren = _.isArray(children) ?
        children.map(c => c?.type?.toString()?.indexOf("fragment") > -1 ? c?.children?.[0] : c) :
        children?.["type"]?.toString()?.indexOf("fragment") > -1 ? children?.["children"]?.[0] : children;

    return (
        <BaseButtonGroup ref={ref} {...rest} {...getDataProps(props)}>
            {sanitizedChildren}
        </BaseButtonGroup>
    );
});
